import { autoinject } from "aurelia-dependency-injection";
import { Logger } from "aurelia-logging";
import { ConsoleAppender } from "aurelia-logging-console";
import { ErrorManager } from "error-management/error-manager";
import { default as stringify } from "json-stringify-safe";

@autoinject()
export class CustomLogAppender extends ConsoleAppender {
    private readonly errorManager: ErrorManager;

    constructor(errorManager: ErrorManager) {
        super();

        this.errorManager = errorManager;
    }

    public debug(logger: Logger, message: any, ...rest: any[]): void {
        super.debug(logger, message, ...rest);
    }

    public info(logger: Logger, message: any, ...rest: any[]): void {
        super.info(logger, message, ...rest);
    }

    public warn(logger: Logger, message: any, ...rest: any[]): void {
        super.warn(logger, message, ...rest);
    }

    public error(logger: Logger, message: any, aiInfo: any, ...rest: any[]): void {
        // All errors catched or generated by Aurelia will go through here (eg: navigation errors, errors thrown in Aurelia lifecycle handlers, etc.)
        // All errors logged by us using an Aurelia logger will also go through here.
        // Let the default logger write to the console, then send the error to the Error Manager for any additional processing (AppInsights, notify the user, etc.)
        // All other errors (windowerror, unhandledrejection) will go to the ErrorManager without passing here first.
        const messageStr = message && message.toString ? message.toString() : String(message);
        if (messageStr.includes("Cannot read properties of undefined") &&
            (messageStr.includes("reading 'name'") || messageStr.includes("reading 'data'"))) {
            // Ne rien faire du tout - ignorer complètement cette erreur
            return;
        }

        let superErrorOccurred = false;
        try {
            super.error(logger, message, aiInfo, ...rest);
        } catch (superError) {
            // IMPORTANT: Si l'erreur "Cannot read properties of undefined (reading 'name')" se produit,
            // on ne fait RIEN - pas de log, pas d'appel à ErrorManager, rien du tout
            const errorMessage = superError && superError.toString ? superError.toString() : String(superError);
            if (errorMessage.includes("Cannot read properties of undefined") &&
                (errorMessage.includes("reading 'name'") || errorMessage.includes("reading 'data'"))) {
                // Ne rien faire du tout - ignorer complètement cette erreur
                return; // IMPORTANT: return ici pour ne PAS appeler ErrorManager
            }
            // Pour les autres erreurs (pas celle de timing), on continue normalement
            superErrorOccurred = true;
        }

        // Envoyer à ErrorManager SEULEMENT si super.error() a réussi et que ce n'est pas une erreur de timing
        // Ne PAS appeler ErrorManager si l'erreur de timing s'est produite (déjà return ci-dessus)
        if (!superErrorOccurred && this.errorManager && typeof this.errorManager.handleError === "function") {
            this.errorManager.handleError(message, aiInfo || {}, stringify(rest));
        }
    }
}
